<a class="nav-link" [href]="fastPerksUrl$ | async" target="_blank" id="nav-dark-web">
  <div class="icon-container">
    <img src="/assets/images/menu/ICN_FastPerks.svg"/>
  </div>
  Perks & Discounts
</a>
<hr />
